import React, { useState } from 'react'
import { Modal, Button, TextField, Select, Banner } from '@ui'
import { inviteOrgAdmin } from '../api.js'

export function InviteAdminModal({ orgId, onClose, onInvited }) {
  const [email, setEmail] = useState('')
  const [name, setName] = useState('')
  const [role, setRole] = useState('admin')
  const [err, setErr] = useState(null)
  const [busy, setBusy] = useState(false)

  async function submit(e) {
    e.preventDefault()
    if (!/.+@.+\..+/.test(email)) { setErr('Enter a valid email.'); return }
    setBusy(true); setErr(null)
    try {
      await inviteOrgAdmin(orgId, { email, role, name: name.trim() || null })
      onInvited?.()
      onClose()
    } catch (e) {
      setErr(e.message || 'Failed to send invite.')
    } finally { setBusy(false) }
  }

  return (
    <Modal open onClose={onClose} title="Invite admin">
      <form onSubmit={submit} style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
        <label>Email
          <TextField type="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
        </label>
        <label>Name (optional)
          <TextField
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="Defaults to the email local part"
            maxLength={120}
          />
        </label>
        <label>Role
          <Select value={role} onChange={(e) => setRole(e.target.value)}>
            <option value="admin">Admin</option>
            <option value="owner">Owner</option>
          </Select>
        </label>
        <Banner tone="info">
          Cognito will send a temporary-password email. If the invite expires, use Resend on the org detail page.
        </Banner>
        {err && <div style={{ color: 'var(--danger-text)' }}>{err}</div>}
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
          <Button type="button" variant="secondary" onClick={onClose}>Cancel</Button>
          <Button type="submit" disabled={busy}>{busy ? 'Sending…' : 'Send invite'}</Button>
        </div>
      </form>
    </Modal>
  )
}
